import React from 'react';
import { WebsiteComponentInteractionPropType } from '../../../../../../../../services/proptypes';
import WebsiteComponentInteraction from '../../../../../../../interactions/components/WebsiteComponentInteraction';
var defaultProps = {};
function Interaction(_ref) {
  var element = _ref.element;
  return /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
    interaction: element
  });
}
Interaction.defaultProps = defaultProps;
export default Interaction;